export interface Environment {
    apiUrl: string;
    development: boolean;
    isRentPropertyEnabled: boolean;
    isMortgageInvEnabled: boolean;
}
